
import React from "react";
import Hero from "../../components/Hero";
import TrustStrip from "../../components/TrustStrip";
import MaterialsSection from "../../components/MaterialsSection";
import B2BSection from "../../components/B2BSection";
import AboutSection from "../../components/AboutSection";
import ContactSection from "../../components/ContactSection";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { useLanguage } from "../../i18n/LanguageContext";

const Index = () => {
  const { t } = useLanguage();

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <SEO
        title={t('seo.index.title')}
        description={t('seo.index.description')}
        canonicalPath="/"
        keywords={t('seo.index.keywords')}
      />
      <Hero />
      <TrustStrip />
      <MaterialsSection />
      <B2BSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
